import { useEffect, useState } from 'react'
import { Plus, Pencil, Trash2, Building2 } from 'lucide-react'
import Topbar from '../components/Topbar'
import api from '../api/client'
import useAppStore from '../store/appStore'

const emptyForm = {
  nome: '', morada: '', codigoPostal: '', localidade: '', nif: '',
  iban: '', transparenciaMode: 'DESATIVADO', fundoReserva: 0, anoInicioQuotas: 2026
}

export default function Condominios() {
  const { condominios, fetchCondominios, condominioAtivo, setCondominioAtivo } = useAppStore()
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(emptyForm)
  const [editId, setEditId] = useState(null)
  const [saving, setSaving] = useState(false)
  const [erro, setErro] = useState('')

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const openCreate = () => { setForm(emptyForm); setEditId(null); setErro(''); setModal(true) }
  const openEdit = (c) => {
    setForm({
      nome: c.nome, morada: c.morada, codigoPostal: c.codigoPostal,
      localidade: c.localidade, nif: c.nif, iban: c.iban || '',
      transparenciaMode: c.transparenciaMode, fundoReserva: c.fundoReserva,
      anoInicioQuotas: c.anoInicioQuotas || 2026
    })
    setEditId(c.id); setErro(''); setModal(true)
  }

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErro('')
    try {
      const payload = { ...form, fundoReserva: parseFloat(form.fundoReserva) || 0, anoInicioQuotas: parseInt(form.anoInicioQuotas) || 2026 }
      if (editId) await api.put(`/condominios/${editId}`, payload)
      else await api.post('/condominios', payload)
      setModal(false)
      await fetchCondominios()
    } catch (err) { setErro(err.response?.data?.erro || err.response?.data?.erros?.[0]?.msg || 'Erro ao guardar.') }
    finally { setSaving(false) }
  }

  const handleDelete = async (c) => {
    if (!window.confirm(`Desativar "${c.nome}"? Os dados são preservados.`)) return
    try { await api.delete(`/condominios/${c.id}`); await fetchCondominios() }
    catch (err) { alert(err.response?.data?.erro || 'Erro.') }
  }

  const anoAtual = new Date().getFullYear()

  return (
    <>
      <Topbar title="Condomínios" actions={
        <button className="btn btn-primary btn-sm" onClick={openCreate}><Plus size={13} /> Novo condomínio</button>
      } />
      <div className="page-content">
        <div className="page-header"><h1>Condomínios</h1><p>{condominios.length} registados</p></div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
          {condominios.map(c => (
            <div key={c.id} className="card" style={{ border: condominioAtivo?.id === c.id ? '2px solid var(--green)' : '' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 8, background: condominioAtivo?.id === c.id ? 'var(--green)' : 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Building2 size={18} color={condominioAtivo?.id === c.id ? '#fff' : 'var(--green-dark)'} />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600 }}>{c.nome}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>NIF: {c.nif}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button className="btn btn-sm" onClick={() => openEdit(c)}><Pencil size={12} /></button>
                  <button className="btn btn-sm" style={{ color: 'var(--red-dark)' }} onClick={() => handleDelete(c)}><Trash2 size={12} /></button>
                </div>
              </div>

              <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 10 }}>
                <div>{c.morada}</div>
                <div>{c.codigoPostal} {c.localidade}</div>
                {c.iban && <div style={{ marginTop: 3, fontFamily: 'monospace', fontSize: 11 }}>{c.iban}</div>}
              </div>

              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
                <span className={`badge badge-${c.ativo ? 'green' : 'gray'}`}>{c.ativo ? 'Ativo' : 'Inativo'}</span>
                <span className="badge badge-blue">{c._count?.fracoes || 0} frações</span>
                <span className="badge badge-gray">Quotas desde {c.anoInicioQuotas || 2026}</span>
                <span className={`badge badge-${c.transparenciaMode === 'DESATIVADO' ? 'gray' : 'green'}`}>
                  Transp. {c.transparenciaMode === 'DESATIVADO' ? 'off' : c.transparenciaMode.toLowerCase()}
                </span>
              </div>

              <button className="btn btn-sm" style={{ width: '100%', justifyContent: 'center', background: condominioAtivo?.id === c.id ? 'var(--green-light)' : '' }}
                onClick={() => setCondominioAtivo(c)}>
                {condominioAtivo?.id === c.id ? '✓ Selecionado' : 'Selecionar'}
              </button>
            </div>
          ))}

          <div className="card" style={{ border: '1px dashed var(--border-strong)', cursor: 'pointer', minHeight: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={openCreate}>
            <div style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>
              <Plus size={28} /><div style={{ fontSize: 13, marginTop: 8 }}>Adicionar condomínio</div>
            </div>
          </div>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal" style={{ width: 540 }}>
            <div className="modal-header">
              <span className="modal-title">{editId ? 'Editar condomínio' : 'Novo condomínio'}</span>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 20 }}>×</button>
            </div>
            {erro && <div className="alert alert-error">{erro}</div>}
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label className="form-label">Nome *</label>
                <input className="form-input" value={form.nome} onChange={e => set('nome', e.target.value)} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">NIF *</label>
                  <input className="form-input" value={form.nif} onChange={e => set('nif', e.target.value)} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Fundo de reserva (€)</label>
                  <input className="form-input" type="number" step="0.01" value={form.fundoReserva} onChange={e => set('fundoReserva', e.target.value)} />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Morada *</label>
                <input className="form-input" value={form.morada} onChange={e => set('morada', e.target.value)} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Código postal *</label>
                  <input className="form-input" placeholder="4100-001" value={form.codigoPostal} onChange={e => set('codigoPostal', e.target.value)} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Localidade *</label>
                  <input className="form-input" value={form.localidade} onChange={e => set('localidade', e.target.value)} required />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">IBAN</label>
                <input className="form-input" placeholder="PT50..." value={form.iban} onChange={e => set('iban', e.target.value)} />
              </div>

              <div style={{ borderTop: '1px solid var(--border)', paddingTop: 14, marginTop: 4 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Configuração de quotas
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div className="form-group">
                    <label className="form-label">Ano de início do cálculo de dívidas</label>
                    <input className="form-input" type="number" min="2000" max={anoAtual + 1} value={form.anoInicioQuotas} onChange={e => set('anoInicioQuotas', e.target.value)} />
                    <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 3 }}>
                      Meses em falta calculados a partir de Janeiro deste ano (por defeito: 2026)
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Transparência financeira</label>
                    <select className="form-select" value={form.transparenciaMode} onChange={e => set('transparenciaMode', e.target.value)}>
                      <option value="DESATIVADO">Desativado — só a própria conta</option>
                      <option value="PARCIAL">Parcial — todas as frações (sem nomes)</option>
                      <option value="TOTAL">Total — frações e nomes visíveis</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? <span className="spinner" /> : editId ? 'Guardar' : 'Criar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
